// extracted by mini-css-extract-plugin
module.exports = {"project":"Project-module--project--yqqy6","projectError":"Project-module--project--error--1HO2V"};